import * as React from 'react';

import { classNames } from '@core/utils/functions/class-names';
import { useState } from 'react';

type MainMenuButtonProps = {
    className?: string;
    accentColor: string;
    primary?: boolean;
    url: string;
    target: string | '' | '_blank';
    title: string;
};

const MainMenuButton = (props: MainMenuButtonProps) => {
    const { className, url, target, title, accentColor, primary } = props;
    const [isHover, setIsHover] = useState(false);

    const style = primary
        ? {
              backgroundColor: isHover ? accentColor || '#254cda' : 'white',
              borderColor: !isHover ? accentColor || '#254cda' : 'white',
              color: !isHover ? accentColor || '#254cda' : 'white',
          }
        : {
              backgroundColor: !isHover ? accentColor || '#254cda' : 'white',
              borderColor: isHover ? accentColor || '#254cda' : 'white',
              color: isHover ? accentColor || '#254cda' : 'white',
          };

    return (
        <div className={classNames('relative', className)}>
            <div className="flex-grow text-sm text-center uppercase text-white">
                <a
                    className={classNames(
                        'px-5 py-4 border border-transparent text-white hover:bg-white',
                        `hover:border-[${accentColor || '#254cda'}] hover:text-[${accentColor || '#254cda'}]`
                    )}
                    style={style}
                    onMouseEnter={() => setIsHover(true)}
                    onMouseLeave={() => setIsHover(false)}
                    href={url}
                    target={target}
                >
                    {title}
                </a>
            </div>
        </div>
    );
};

export default MainMenuButton;
